<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <asignar-tipo-contrato-dialog
        v-model="individualAssignmentDialog"
        :item="selectedItem"
        @assigned="asignacionIndividualCompletada"
      />

      <v-dialog v-model="massiveAssignmentDialog" max-width="680px" persistent>
        <v-card>
          <v-card-title>Asignar tipo de contrato a puestos seleccionados</v-card-title>
          <v-card-text>
            <div class="text-body-2 mb-2">
              Se asignará el mismo tipo de contrato a los siguientes puestos:
            </div>
            <v-list dense class="mb-4">
              <v-list-item v-for="item in assignmentItems" :key="item.id_empleado_puesto">
                <v-list-item-content>
                  <v-list-item-title>{{ getEmployeeName(item) }}</v-list-item-title>
                  <v-list-item-subtitle>
                    Código: {{ item.codigo_empleado || "-" }} · Puesto: {{ item.nombre_puesto || "-" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Género: {{ getGenero(item.genero) }} · Periodo: {{ getPeriod(item) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-autocomplete
              v-model="selectedContract"
              :items="contractOptions"
              item-value="id_empleado_contrato"
              item-text="nombre"
              label="Tipo de contrato"
              outlined
              dense
              clearable
              :loading="loadingContracts"
              :disabled="loadingContracts || savingAssignment"
              hide-details="auto"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeAssignmentDialog" :disabled="savingAssignment">Cancelar</v-btn>
            <v-btn
              color="red"
              text
              @click="assignContracts"
              :loading="savingAssignment"
              :disabled="!selectedContract || loadingContracts"
            >
              Asignar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.codigoEmpleado"
            label="Código de empleado"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-model.lazy="search.nombre"
            label="Nombre"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-model.lazy="search.apellidoPaterno"
            label="Apellido Paterno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-model.lazy="search.apellidoMaterno"
            label="Apellido Materno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.rfc"
            label="RFC"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="10" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="3">
              <v-autocomplete
                v-model="search.tipoPuestos"
                :items="areaPuestos"
                item-value="id_rh_area"
                item-text="nombre"
                label="Tipos de Puestos"
                outlined
                dense
                hide-details
                multiple
                chips
                deletable-chips
                clearable
                @change="changeTipoPuestos"
              />
            </v-col>

            <v-col cols="3">
              <v-autocomplete
                v-model="search.puestos"
                label="Puestos"
                clearable
                :items="puestosFiltrados"
                item-value="id_puesto"
                item-text="nombre"
                dense
                hide-details
                outlined
                multiple
                chips
                deletable-chips
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <v-select
                v-model="search.genero"
                :items="generos"
                item-value="value"
                item-text="text"
                label="Género"
                clearable
                dense
                hide-details
                outlined
              ></v-select>
            </v-col>

            <v-col cols="3">
              <v-select
                v-model="search.anio"
                :items="years"
                label="Año"
                clearable
                dense
                hide-details
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-btn
            block
            color="primary"
            text
            outlined
            @click="getItems"
            :disabled="loading"
            :loading="loading"
          >
            <v-icon>
              mdi-magnify
            </v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      
      <br>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="10"
        item-key="id_empleado_puesto"
        show-select
        checkbox-color="primary"
        dense
      >
        <template v-slot:[`item.fecha_hasta`]="{ item }">{{ item.fecha_hasta || "Vigente" }}</template>
        <template v-slot:[`item.genero`]="{ item }">{{ getGenero(item.genero) }}</template>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip bottom color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                small
                v-bind="attrs"
                v-on="on"
                @click="openIndividualAssignmentDialog(item)"
              >
                mdi-file-cog-outline
              </v-icon>
            </template>
            <span>Asignar tipo de contrato</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>No hay puestos sin tipo de contrato asignado.</template>
      </v-data-table>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-btn
            color="primary"
            block
            :disabled="selected.length === 0"
            @click="openMassiveAssignmentDialog"
          >
            <v-icon left>mdi-file-document-edit</v-icon>
            Asignar Tipo de Contrato a Puestos Seleccionados
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios"
import VAlertDialog from "@/components/VAlertDialog.vue"
import AsignarTipoContratoDialog from "./AsignarTipoContratoDialog.vue"

export default {
  components: { VAlertDialog, AsignarTipoContratoDialog },
  data: () => ({
    loading: false,
    items: [],
    areaPuestos: [],
    puestos: [],
    loadingAreaPuestos: false,
    loadingPuestos: false,
    loadingContracts: false,
    savingAssignment: false,
    individualAssignmentDialog: false,
    massiveAssignmentDialog: false,
    selected: [],
    selectedItem: null,
    assignmentItems: [],
    contractOptions: [],
    selectedContract: null,
    generos: [
      { text: "Femenino", value: 0 },
      { text: "Masculino", value: 1 }
    ],
    search: {
      codigoEmpleado: "",
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      rfc: "",
      genero: null,
      anio: null,
      tipoPuestos: [],
      puestos: []
    },
    headers: [
      { text: "Código", value: "codigo_empleado", align: "center" },
      { text: "Empleado", value: "nombre", align: "left" },
      { text: "Puesto", value: "nombre_puesto", align: "left" },
      { text: "Género", value: "genero", align: "center" },
      { text: "Desde", value: "fecha_desde", align: "center" },
      { text: "Hasta", value: "fecha_hasta", align: "center" },
      { text: "Acciones", value: "acciones", align: "center", sortable: false }
    ]
  }),
  computed: {
    maxYear() {
      return new Date().getFullYear() + 1
    },
    years() {
      return Array.from({ length: this.maxYear - 2026 + 1 }, (_, index) => 2026 + index)
    },
    puestosFiltrados() {
      if (!this.search.tipoPuestos || this.search.tipoPuestos.length === 0) return this.puestos
      return this.puestos.filter(puesto => this.search.tipoPuestos.includes(puesto.id_rh_area))
    }
  },
  mounted() {
    this.getItems()
    this.getPuestos()
    this.getRHAreas()
  },
  methods: {
    getUrl() {
      const url = new URL("http://localhost/RecursosHumanos/ListarEmpleadoPuestosSinContrato")
      const search = this.search
      if (search.codigoEmpleado) url.searchParams.append("codigo_empleado", search.codigoEmpleado)
      if (search.nombre) url.searchParams.append("nombre", search.nombre)
      if (search.apellidoPaterno) url.searchParams.append("apellido_paterno", search.apellidoPaterno)
      if (search.apellidoMaterno) url.searchParams.append("apellido_materno", search.apellidoMaterno)
      if (search.rfc) url.searchParams.append("rfc", search.rfc)
      if (search.genero !== null && search.genero !== "") url.searchParams.append("genero", search.genero)
      if (search.anio) url.searchParams.append("anio", search.anio)
      search.tipoPuestos.forEach(id => url.searchParams.append("ids_rh_areas", id))
      search.puestos.forEach(id => url.searchParams.append("ids_puestos", id))
      return url.href.replace("http://localhost", "")
    },
    getItems() {
      if (this.search.anio && Number(this.search.anio) > this.maxYear) {
        this.showAlert("El año no puede ser mayor a " + this.maxYear + ".")
        return
      }

      this.loading = true
      axios.get(this.getUrl())
        .then(response => {
          this.items = response.data || []
          this.selected = []
        })
        .catch(() => { this.showAlert("No se pudieron obtener los puestos sin contrato.") })
        .finally(() => { this.loading = false })
    },
    getPuestos() {
      this.loadingPuestos = true
      axios.get("/RecursosHumanos/ListarPuestos")
        .then(response => { this.puestos = response.data || [] })
        .catch(() => { this.showAlert("No se pudieron obtener los puestos.") })
        .finally(() => { this.loadingPuestos = false })
    },
    getRHAreas() {
      this.loadingAreaPuestos = true
      axios.get("/RHCatalogos/ListarRHAreas")
        .then(response => { this.areaPuestos = response.data || [] })
        .catch(() => { this.showAlert("No se pudieron obtener las áreas de Recursos Humanos.") })
        .finally(() => { this.loadingAreaPuestos = false })
    },
    changeTipoPuestos() {
      this.search.puestos = []
    },
    openIndividualAssignmentDialog(item) {
      this.selectedItem = item
      this.individualAssignmentDialog = true
    },
    asignacionIndividualCompletada() {
      this.selected = []
      this.getItems()
    },
    openMassiveAssignmentDialog() {
      this.selectedItem = null
      this.openAssignmentDialog(this.selected, "massive")
    },
    openAssignmentDialog(items, mode) {
      if (!items || items.length === 0) return

      this.assignmentItems = items.slice()
      this.selectedContract = null
      this.contractOptions = []
      this.individualAssignmentDialog = mode === "individual"
      this.massiveAssignmentDialog = mode === "massive"
      this.loadingContracts = true

      const request = mode === "massive"
        ? axios.post("/RecursosHumanos/ListarCatalogoEmpleadoContratosPorPuestos", {
            ids_empleado_puesto: items.map(item => item.id_empleado_puesto)
          })
        : axios.get(`/RecursosHumanos/ListarCatalogoEmpleadoContratos/${this.selectedItem.id_empleado_puesto}`)

      request
        .then(response => { this.contractOptions = response.data || [] })
        .catch(error => {
          if (error.response && error.response.status === 409) {
            const message = error.response.data && error.response.data.msg
              ? error.response.data.msg.replace("Error : ", "")
              : "No se pudo obtener el catálogo de tipos de contrato."
            this.showAlert(message)
            return
          }

          this.showAlert("No se pudieron obtener los tipos de contrato.")
        })
        .finally(() => { this.loadingContracts = false })
    },
    closeAssignmentDialog() {
      this.individualAssignmentDialog = false
      this.massiveAssignmentDialog = false
      this.selectedItem = null
      this.assignmentItems = []
      this.contractOptions = []
      this.selectedContract = null
    },
    async assignContracts() {
      if (!this.selectedContract || this.assignmentItems.length === 0) return

      this.savingAssignment = true
      try {
        for (const item of this.assignmentItems) {
          await axios.post("/RecursosHumanos/AsignarEmpleadoContrato", {
            id_empleado_puesto: item.id_empleado_puesto,
            id_empleado_contrato: this.selectedContract
          })
        }

        this.closeAssignmentDialog()
        this.selected = []
        this.getItems()
      } catch (error) {
        if (error.response && error.response.status === 409) {
          const message = error.response.data && error.response.data.msg
            ? error.response.data.msg.replace("Error : ", "")
            : "El puesto del empleado ya tiene un tipo de contrato asignado."
          this.$refs.alert.setMessage("", message)
          this.$refs.alert.open()
          return
        }

        this.showAlert("No se pudo asignar el tipo de contrato.")
      } finally {
        this.savingAssignment = false
      }
    },
    getEmployeeName(item) {
      return [item.nombre, item.apellido_paterno, item.apellido_materno]
        .filter(Boolean)
        .join(" ") || "Empleado sin nombre"
    },
    getPeriod(item) {
      return `${item.fecha_desde || "-"} a ${item.fecha_hasta || "Vigente"}`
    },
    getGenero(genero) {
      const opcion = this.generos.find(item => item.value === genero)
      return opcion ? opcion.text : "-"
    },
    showAlert(message) {
      this.$refs.alert.setMessage("", message)
      this.$refs.alert.open()
    },
  }
}
</script>
